import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';
import { bdlGray } from 'box-ui-elements/es/styles/variables';

type Props = {
  className?: string;
  color?: string;
  height?: number;
  title?: string;
  width?: number;
};

const BoldIcon = ({
  className = '',
  color = bdlGray,
  height = 16,
  title,
  width = 16,
}: Props) => (
  <AccessibleSVG
    className={className}
    height={height}
    title={title}
    viewBox="0 0 16 16"
    width={width}
  >
    <path
      clipRule="evenodd"
      d="M8.58396 14C9.28918 14 9.91605 13.9115 10.4646 13.7344C11.0131 13.5574 11.4748 13.3126 11.8498 13C12.2248 12.6874 12.5103 12.3154 12.7062 11.8838C12.9021 11.4523 13 10.982 13 10.473C13 9.06224 12.166 8.17151 10.4981 7.80083C10.8731 7.67358 11.1964 7.51867 11.4678 7.3361C11.7393 7.15353 11.9632 6.95021 12.1395 6.72614C12.3158 6.50207 12.4459 6.26141 12.5299 6.00415C12.6138 5.74689 12.6558 5.47718 12.6558 5.19502C12.6558 4.70263 12.5718 4.26003 12.4039 3.86722C12.236 3.47441 11.9715 3.1397 11.6105 2.86307C11.2495 2.58645 10.7864 2.37344 10.2211 2.22407C9.65578 2.07469 8.97575 2 8.18097 2H5C4.44772 2 4 2.44772 4 3V13C4 13.5523 4.44772 14 5 14H8.58396ZM6.2584 7.19502V3.72614H8.18097C8.94216 3.72614 9.50187 3.85892 9.86007 4.12448C10.2183 4.39004 10.3974 4.83541 10.3974 5.46058C10.3974 6.06362 10.2001 6.50346 9.8055 6.78008C9.41091 7.05671 8.82743 7.19502 8.05504 7.19502H6.2584ZM6.2584 8.73859V12.2573H8.54198C8.96175 12.2573 9.31437 12.2075 9.59981 12.1079C9.88526 12.0083 10.1133 11.8755 10.284 11.7095C10.4548 11.5436 10.5779 11.3499 10.6535 11.1286C10.729 10.9073 10.7668 10.6722 10.7668 10.4232C10.7668 10.1632 10.7248 9.92946 10.6409 9.72199C10.5569 9.51452 10.4254 9.33748 10.2463 9.19087C10.0672 9.04426 9.83629 8.93223 9.55364 8.85477C9.27099 8.77732 8.93097 8.73859 8.53358 8.73859H6.2584Z"
      fill={color}
      fillRule="evenodd"
    />
  </AccessibleSVG>
);

export default BoldIcon;
